import { useSelector, useDispatch } from 'react-redux'

// Actions
import { actions as profileActions } from 'modules/profile/actions'

// Components
import ProfileForm from 'components/profile/profileform'

// Hooks
import { useProfile } from 'modules/profile/hooks'

// Types
import { Dispatch, Country, Profile, State } from 'types'

const ProfileFormView = () => {
  const dispatch = useDispatch() as Dispatch
  const profile = useProfile()
  const countryOptions = useSelector<State, Array<Country>>(state => state.entities.countryOptions)

  return (
    <ProfileForm
      onSubmit={(data: Partial<Profile>) => {
        const fixedData = {
          ...data,
          show_prices_with_vat: !!data.show_prices_with_vat,
        }
        return dispatch(profileActions.updateProfile(fixedData, profile.id))
      }}
      countryOptions={countryOptions}
      profile={profile}
    />
  )
}

export default ProfileFormView
